import { Field, FieldProps } from 'formik';
import { getErrorForDisplay } from '@/components/FormikRedux/useFormikError';
import {
  SelectControl,
  SingleSelectControlProps,
} from '@/components/SelectControl';
import { RequiredAny } from 'ui-kit/lib/types';
import { INHERITED_DATA_TEST_ID } from '@/utils/testId.ts';

type Props<T> = Omit<SingleSelectControlProps<T>, 'name' | 'value'> & {
  name: string;
};

export const SelectControlF = <T = string,>({
  children,
  ...props
}: Props<T>) => {
  return (
    <Field {...props}>
      {({ field, form, meta }: FieldProps) => {
        const e = getErrorForDisplay({
          error: meta.error,
          value: meta.value,
          touched: meta.touched,
          submitCount: form.submitCount,
        });
        return (
          <SelectControl<T>
            data-test-id={INHERITED_DATA_TEST_ID}
            {...(props as RequiredAny)}
            {...field}
            value={field.value ?? ''}
            error={e}
          >
            {children}
          </SelectControl>
        );
      }}
    </Field>
  );
};
